(function () {
  'use strict';

  var API_BASE = 'https://dashboards.dirtsstore.com/api/v1/feedback';

  function $(id) { return document.getElementById(id); }

  var params = new URLSearchParams(location.search);
  var token = params.get('t') || '';

  var state = {
    rating: 0,
    body: '',
    pictureUrls: [],
    submitting: false
  };

  function showState(name) {
    var ids = ['loading', 'form', 'already', 'expired', 'invalid', 'thanks'];
    ids.forEach(function (s) {
      var el = $('dr-' + s);
      if (el) el.hidden = (s !== name);
    });
  }

  if (!token) {
    showState('invalid');
    return;
  }

  // --- Verify on load ---
  fetch(API_BASE + '/verify?t=' + encodeURIComponent(token))
    .then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (body) {
        return { status: r.status, body: body };
      });
    })
    .then(function (res) {
      if (res.status === 410) return showState('expired');
      if (res.status >= 400 || !res.body || !res.body.valid) return showState('invalid');
      if (res.body.already_reviewed) return renderAlready(res.body);
      return renderForm(res.body);
    })
    .catch(function (e) {
      console.error('verify failed', e);
      showState('invalid');
    });

  function renderForm(data) {
    $('dr-product-title').textContent = (data.product && data.product.title) || 'Your purchase';
    var img = $('dr-product-image');
    if (data.product && data.product.image_url) {
      img.src = data.product.image_url;
      img.alt = data.product.title || '';
    } else {
      img.style.display = 'none';
    }
    $('dr-order-num').textContent = data.order_number || '';
    $('dr-greeting-name').textContent = data.customer_first_name || 'there';
    showState('form');

    bindStarPicker();
    bindTextarea();
    bindPhotos();
    bindSubmit();
  }

  function renderAlready(data) {
    if (data.existing) {
      var r = data.existing.rating | 0;
      var filled = '★★★★★'.slice(0, r);
      var empty = '☆☆☆☆☆'.slice(0, 5 - r);
      $('dr-existing-stars').textContent = filled + empty;
      $('dr-existing-body').textContent = data.existing.body || '';
    }
    showState('already');
  }

  function bindStarPicker() {
    var stars = document.querySelectorAll('.dr-star');
    stars.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var r = parseInt(btn.dataset.star, 10);
        state.rating = r;
        $('dr-stars').dataset.rating = String(r);
        stars.forEach(function (b) {
          b.classList.toggle('active', parseInt(b.dataset.star, 10) <= r);
        });
        updateSubmitState();
      });
    });
  }

  function bindTextarea() {
    var ta = $('dr-comment');
    ta.addEventListener('input', function () {
      state.body = ta.value;
      $('dr-char-count').textContent = ta.value.length;
      updateSubmitState();
    });
  }

  function bindPhotos() {
    var input = $('dr-photo-input');
    var addBtn = $('dr-add-photo');
    addBtn.addEventListener('click', function () { input.click(); });
    input.addEventListener('change', function () {
      var file = input.files && input.files[0];
      input.value = '';
      if (!file) return;
      $('dr-photo-error').hidden = true;
      if (state.pictureUrls.length >= 4) return showPhotoError('Maximum 4 photos allowed');
      if (file.size > 5 * 1024 * 1024) return showPhotoError('Image too large (max 5 MB)');

      // Optimistic placeholder thumb
      var placeholder = document.createElement('div');
      placeholder.className = 'dr-photo-thumb dr-photo-uploading';
      placeholder.textContent = '…';
      $('dr-photo-grid').appendChild(placeholder);

      var reader = new FileReader();
      reader.onload = function (e) { placeholder.innerHTML = '<img src="' + e.target.result + '" alt="">'; };
      reader.readAsDataURL(file);

      var fd = new FormData();
      fd.append('t', token);
      fd.append('file', file);

      fetch(API_BASE + '/upload', { method: 'POST', body: fd })
        .then(function (res) {
          if (!res.ok) {
            return res.json().catch(function () { return {}; }).then(function (e) {
              var msg = (e && (e.detail && (e.detail.error || e.detail) || e.error)) || ('HTTP ' + res.status);
              throw new Error(msg);
            });
          }
          return res.json();
        })
        .then(function (data) {
          var url = data.url;
          state.pictureUrls.push(url);
          placeholder.innerHTML =
            '<img src="' + url + '" alt=""><button class="dr-photo-remove" type="button" aria-label="Remove photo">×</button>';
          placeholder.classList.remove('dr-photo-uploading');
          var removeBtn = placeholder.querySelector('.dr-photo-remove');
          removeBtn.addEventListener('click', function () {
            var idx = state.pictureUrls.indexOf(url);
            if (idx > -1) state.pictureUrls.splice(idx, 1);
            placeholder.remove();
            addBtn.disabled = state.pictureUrls.length >= 4;
          });
          addBtn.disabled = state.pictureUrls.length >= 4;
        })
        .catch(function (e) {
          placeholder.remove();
          showPhotoError('Upload failed: ' + e.message);
        });
    });
  }

  function showPhotoError(msg) {
    var e = $('dr-photo-error');
    e.textContent = msg;
    e.hidden = false;
  }

  function bindSubmit() {
    $('dr-submit').addEventListener('click', submit);
  }

  function updateSubmitState() {
    $('dr-submit').disabled = !(state.rating > 0 && state.body.trim().length >= 5);
  }

  function submit() {
    if (state.submitting) return;
    state.submitting = true;
    var btn = $('dr-submit');
    btn.disabled = true;
    btn.textContent = 'Submitting…';
    $('dr-submit-error').hidden = true;

    fetch(API_BASE + '/submit', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        token: token,
        rating: state.rating,
        body: state.body.trim(),
        picture_urls: state.pictureUrls.length ? state.pictureUrls : undefined
      })
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().catch(function () { return {}; }).then(function (e) {
            var msg = (e && e.detail && (e.detail.error || e.detail)) || ('HTTP ' + res.status);
            throw new Error(msg);
          });
        }
        return res.json();
      })
      .then(function () {
        showState('thanks');
      })
      .catch(function (e) {
        state.submitting = false;
        btn.disabled = false;
        btn.textContent = 'Submit Review';
        var errEl = $('dr-submit-error');
        errEl.textContent = 'Could not submit: ' + e.message + '. Please try again.';
        errEl.hidden = false;
      });
  }
})();
